<template>
  <div class="rule-add">
    <el-form v-if="isEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="商品名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入商品名称" />
      </el-form-item>
      <el-form-item label="商品类型" prop="productType">
        <el-radio-group  v-model="form.productType" :disabled="id?true:false" @change="onProductTypeChange" >
          <el-radio label="Coupon">优惠券</el-radio>
          <el-radio label="GiftCoupon">礼品券</el-radio>
          <el-radio label="LotCoupon">停车券</el-radio>
          <el-radio label="Commodity">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选择券" prop="productId" v-if="form.productType != 'Commodity'">
        <el-select v-model="form.productId" placeholder="请选择券" @change="onCouponChange" collapse-tags :disabled="id?true:false">
          <el-option v-for="item in couponSelectData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table" v-if="form.productType != 'Commodity'">
        <Table :tableThData="tableThData" :tableTrData="tableTrData" :pagination="false" >
            <template #name="{ row }">{{ row.name }}</template>
            <template #type="{ row }">{{ row.type }}</template>
            <template #detail="{ row }">{{ row.detail }}</template>
            <template #require="{ row }">{{ row.require }}</template>
            <template #useTime="{ row }">{{ row.useTime }}</template>
            <template #subTitle="{ row }">{{ row.subTitle }}</template>
            <template #mallName="{ row }">{{ row.mallName }}</template>
            <template #discount="{ row }">{{ row.discount }}</template>
            <template #validTime="{ row }">{{ row.validTime }}</template>
            <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
            <template #description="{ row }">
              <el-tooltip placement="right" effect="light">
                <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">{{ row.description }}</div>
                <div style="white-space: pre-wrap; width: 200px;" slot="content">{{ row.description }}</div>
              </el-tooltip>
            </template>
        </Table>
      </div>
      <el-form-item label="商品图片" prop="picture"  :rules="form.productType == 'Commodity' ? [{ required: true, message: '请上传商品图片'},] : []">
        <UploadImg  @getUploadFile="getUploadFile" :uploadUrl="form.picture" :desc="'建议：上传165*160的png的图片'"></UploadImg>
      </el-form-item>
      <el-form-item label="兑换限制" prop="userTotal">
        <el-radio-group v-model="form.userTotal"  @change="limitRadioChange('userTotalLimit')">
          <el-radio label="1">无限制</el-radio>
          <el-radio label="2" class="limit-pay-box">
            <span>总兑换次数</span>
            <el-form-item label="" class="radioInput" prop="userTotalLimit">
              <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="form.userTotalLimit" placeholder="请输入"  :disabled="form.userTotal !== '2'">
                <template slot="append">次数</template>
              </el-input>
            </el-form-item>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="售价(积分)" prop="point">
        <el-input oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" placeholder="请输入正整数" v-model="form.point" class="input" :maxLength="9">
          <template slot="append">积分</template>
        </el-input>
      </el-form-item>
      <el-form-item label="售价(金额)" prop="amount">
      <el-input type="number" placeholder="请输入金额" v-model="form.amount" class="input" :maxLength="9">
          <template slot="append">元</template>
        </el-input>
       <span style="color: #999999;margin-left:5px;">(不允许单独设置金额支付)</span>
      </el-form-item>
      <el-form-item label="上架数量" prop="quantity">
        <el-input  oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入正整数" v-model="form.quantity" class="input">
          <template slot="append">个</template>
        </el-input>
      </el-form-item>
      <el-form-item label="售卖时间" prop="salesTime">
        <el-date-picker
          v-model="form.salesTime"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator=""
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="上架状态" prop="effective">
        <el-radio-group  v-model="form.effective">
          <el-radio :label="0">下架</el-radio>
          <el-radio :label="1">上架</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="描述" prop="remark">
        <el-input  type="textarea" rows="6" v-model="form.remark" maxlength="2000" placeholder="请输入描述" show-word-limit />
      </el-form-item>
    </el-form>
      <!-- 详情信息 -->
      <el-form ref="form" v-else :model="form" :rules="rules" hide-required-asterisk label-width="100px">
        <el-form-item label="商品名称" prop="name">
          <span >{{ form.name }}</span>
        </el-form-item>
        <el-form-item label="商品类型" prop="productType">
          <span >{{ form.productTypeName }}</span>
        </el-form-item>
        <el-form-item label="选择券" prop="productId" v-if="form.productType != 'Commodity'">
          <span>{{ form.productDetails?form.productDetails.name:'' }}</span>
        </el-form-item>
        <div class="coupon-table" v-if="form.productType != 'Commodity'">
          <Table :tableThData="tableThDataDis" :tableTrData="tableTrData" :pagination="false" >
              <template #name="{ row }">{{ row.name }}</template>
              <template #type="{ row }">{{ row.type }}</template>
              <template #detail="{ row }">{{ row.detail }}</template>
              <template #require="{ row }">{{ row.require }}</template>
              <template #useTime="{ row }">{{ row.useTime }}</template>
              <template #subTitle="{ row }">{{ row.subTitle }}</template>
              <template #mallName="{ row }">{{ row.mallName }}</template>
              <template #discount="{ row }">{{ row.discount }}</template>
              <template #validTime="{ row }">{{ row.validTime }}</template>
              <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
              <template #description="{ row }">
                <el-tooltip placement="right" effect="light">
                  <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">{{ row.description }}</div>
                  <div style="white-space: pre-wrap; width: 200px;" slot="content">{{ row.description }}</div>
                </el-tooltip>
              </template>
              <template #remark="{ row }">
                <el-tooltip placement="right" effect="light">
                  <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">{{ row.remark }}</div>
                  <div style="white-space: pre-wrap; width: 200px;" slot="content">{{ row.remark }}</div>
                </el-tooltip>
              </template>
          </Table>
        </div>
        <el-form-item label="商品图片" prop="picture"  :rules="form.productType == 'Commodity' ? [{ required: true, message: '请上传商品图片'},] : []">
          <el-col :span="22" class="col-value" v-if="form.picture">
              <div class="logo-box">
                <el-image v-if="form.picture" :src="form.picture" class="img" fit="contain" />
              </div>
            </el-col>
          <span v-else>{{ '暂无图片' }}</span>
        </el-form-item>
        <el-form-item label="兑换限制" prop="userTotal">
          <span >{{ form.userTotal == 1 ? '无限制' : form.userTotalLimit + '次数' }}</span>
        </el-form-item>
        <el-form-item label="售价" prop="point">
          <span>{{ form.point }}积分{{ form.amount ? '+'+form.amount + '元':'' }}</span>
        </el-form-item>
        <el-form-item label="上架数量" prop="quantity">
          <span>{{ form.quantity }}</span>
        </el-form-item>
        <el-form-item label="售卖时间" prop="salesTime">
          <span >{{ form.salesTimeString }}</span>
        </el-form-item>
        <el-form-item label="上架状态" prop="effective">
          <span >{{ form.effective == 1 ? '上架' : '下架' }}</span>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <span>{{ form.remark }}</span>
        </el-form-item>
      </el-form>
      <div class="footer" v-if="isEdit">
        <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
      </div>
      <div v-if="isScoreShopEdit&&!isEdit" class="button-box right">
        <auth-button auth="market:activity:update">
        <el-button type="primary" @click="onEdit(form.productType)" :loading="submitLoading">编辑</el-button>
        </auth-button>
      </div>
      <!-- 兑换记录 -->
    <div class="point-record" v-if="!isEdit">
        <el-divider />
        <div class="title">兑换记录</div>
        <PointRecord></PointRecord>
      </div>
  </div>
</template>

<script>
import { api_postAddPointMallCreate, api_putUpdatePointMallCreate,api_getPointMall } from '@/api/scoreShop'
import { api_getListCoupon, api_getGiftListCoupon, api_postFileUpload,api_getListRTCoupon } from '@/api/common'
import { api_getParkingCouponTemplate } from '@/api/parking'
import PointRecord from './components/pointRecord'
import AuthButton from '@/components/AuthButton'
import Table from "@/components/Table/index";
import UploadImg from '@/components/UploadImg/index'
export default {
  name: "memberGradeAdd",
  components: {
    Table,
    UploadImg,
    AuthButton,
    PointRecord
  },
  data() {
    // 校验金额
    const checkAmount = (rule, value, callback) => {
      // console.log('value: ', value);
      // if(value == undefined) return
      let rep = /[\.]/
      if (rep.test(value * 10)) {
        callback(new Error('售价(金额)仅支持一位小数'))
      } else if(value < 0 ){
        callback(new Error('售价(金额)不能小于0'))
      }else{
        callback()
      }
    }

    return {
      pickerOptions:{
        disabledDate (time) {
          return time.getTime() < Date.now()-1 * 24 * 3600 * 1000 //选当前时间之后的时间
        }
      },
      form: {
        userTotal: '1',
        name: '',
        productType: 'Coupon',
        productId: '',
        picture: '',
        point: '',
        quantity: '',
        salesTime: [],
        effective: 0,
        remark: '',
      },
      tableThData: [],
      tableTrData: [],
      couponSelectData: [], // 券下拉框数据
      couponListData: [], // 优惠券list数据
      giftCouponListData: [], // 礼品券list数据
      parkingCouponListData:[],// 停车券list数据
      rules: {
        name: [{ required: true, message: '请输入商品名称' }],
        productType: [{ required: true, message: '请选择商品类型' }],
        productId: [{ required: true, message: '请选择券' }],
        point: [{ required: true, message: '请输入售价' }],
        amount: [{ validator: checkAmount }],
        quantity: [{ required: true, message: '请输入上架数量' }],
        salesTime: [{ required: true, message: '请选择售卖使劲' }],
        effective: [{ required: true, message: '请选择上架状态' }],
      },
      mallList: [],
      storeList: [],
      categoryList: [],
      useRangeOption: [{
        label: '商城',
        value: 'Mall'
      }, {
        label: '业态',
        value: 'Category'
      }, {
        label: '店铺',
        value: 'Store'
      }],
      shopCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      },
      submitLoading: false,
      isEdit: true,
      isScoreShopEdit:false,
      id: '',
      detail: {
        productDetails: ''
      },
      tableThDataDis:[]
    };
  },
  created() {
      this.getCouponListData()
      this.getGiftCouponListData()
      this.getparkingCouponListData()
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getDetailDate() // 获取详情数据
    }
    
  },
  methods: {
    getUploadFile (file) {
      this.form.picture = file
    },
    // 获取优惠券列表数据
    async getCouponListData() {
      const res = await api_getListRTCoupon()
      this.couponListData = res
      this.couponSelectData = this.couponListData
      this.tableThData = [
        { prop: "name", label: "优惠券名称", minWidth: "200", },
        { prop: "type", label: "券类型", minWidth: "200", },
        { prop: "require", label: "券门槛", minWidth: "200", },
        { prop: "useTime", label: "用券时间", minWidth: "200", },
        { prop: "useRangeType", label: "使用范围", minWidth: "200", },
      ]
    },
    // 获取礼品券列表数据
    async getGiftCouponListData() {
      const res = await api_getGiftListCoupon()
      this.giftCouponListData = res
    },
     // 获停车券列表数据
    async getparkingCouponListData() {
      const res = await api_getParkingCouponTemplate()
      this.parkingCouponListData = res
    },
    // 券类型改变
    onProductTypeChange(value) {
      this.form.productId = ''
      setTimeout(()=>{
        this.$refs['form'].clearValidate(['productId']);
      },0)
      this.tableTrData = []
      if (value === 'Coupon') {
        this.couponSelectData = this.couponListData
        this.tableThData = [
          { prop: "name", label: "优惠券名称", minWidth: "200", },
          { prop: "type", label: "券类型", minWidth: "200", },
          { prop: "require", label: "券门槛", minWidth: "200", },
          { prop: "useTime", label: "用券时间", minWidth: "200", },
          { prop: "useRangeType", label: "使用范围", minWidth: "200", },
        ]
      } else if (value === 'GiftCoupon') {
        this.couponSelectData = this.giftCouponListData
        this.tableThData = [
          { prop: "name", label: "礼品券名称", minWidth: "200", },
          { prop: "subTitle", label: "礼品券标题", minWidth: "200", },
          { prop: "useTime", label: "券有效时间", minWidth: "200", },
          { prop: "useRangeType", label: "使用范围", minWidth: "200", },
        ]
      }else if (value === 'LotCoupon') {
        this.couponSelectData = this.parkingCouponListData
        this.tableThData = [
        { prop: "name", label: "停车券名称", minWidth: "200", },
        { prop: "mallName", label: "商场名", minWidth: "200", },
        { prop: "discount", label: "抵扣", minWidth: "200", },
        { prop: "validTime", label: "券有效时间", minWidth: "200", },
        { prop: "remark", label: "说明", minWidth: "200", },
        ]
      }
    },
    // 券下拉框改变
    onCouponChange(value) {
      const curCoupon = this.couponSelectData.filter(item => item.id == value)
      this.tableTrData = curCoupon
    },
    // 获取详情数据
    async getDetailDate() {
      this.isEdit = false
      let res = await api_getPointMall({ id: this.$route.query.id })
      this.form.userTotal = res.userTotalLimit || res.userTotalLimit === 0 ? '2' : '1'
      let total = this.form.userTotal
      this.form = {
        ...res,
        salesTime: [res.salesStartTime, res.salesEndTime],
        salesTimeString:res.salesTime,
        userTotal:total
      }
      this.form.productType = res.productType
      if (this.form.productType != 'Commodity') {
        this.form.productId = res.productDetails.id
        this.tableTrData = [this.form.productDetails]
        this.tableThDataDis = this.form.columnList.map((item)=> {
          return {
            prop: item.valueKey, label: item.displayName, minWidth: "200"
          }
        })
      }
      this.form.effective == 0 ? this.isScoreShopEdit = true : this.isScoreShopEdit = false  // 查看详情时，上架只能看信息，下架可以编辑
      setTimeout(()=> {
        this.$refs['form'].clearValidate()
      }, 0) 
      
    },
   // 限制 单选器改变
    limitRadioChange(name) {
      this.$refs.form.validateField(name)
      this.form[name] = null
      delete this.form[name]
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
            salesStartTime: this.form.salesTime && this.form.salesTime[0] ? this.form.salesTime[0] : null,
            salesEndTime: this.form.salesTime && this.form.salesTime[1] ? this.form.salesTime[1] : null,
          }
          if(!params.amount || params.amount.length == 0){
            params.amount = '0'
          }
          if (params.userTotal == 1) {
            delete params.userTotalLimit
          }
          delete params.userTotal
          if (this.form.picture&&this.form.picture.size) {
            const { key } = await api_postFileUpload(this.form.picture, 'PointMall')
            params.picture = key
          }
          try {
            delete params.salesTime
            delete params.columnList
            delete params.productDetails
            delete params.productTypeName
            delete params.soldQuantity
            let res = params.id ? await api_putUpdatePointMallCreate(params) : await api_postAddPointMallCreate(params)
            console.log('res: ', res);
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
    onEdit(value){
      this.isEdit = true
      if (value === 'Coupon') {
        this.couponSelectData = this.couponListData
        this.tableThData = [
          { prop: "name", label: "优惠券名称", minWidth: "200", },
          { prop: "type", label: "券类型", minWidth: "200", },
          { prop: "require", label: "券门槛", minWidth: "200", },
          { prop: "useTime", label: "用券时间", minWidth: "200", },
          { prop: "useRangeType", label: "使用范围", minWidth: "200", },
        ]
      } else if (value === 'GiftCoupon') {
        this.couponSelectData = this.giftCouponListData
        this.tableThData = [
          { prop: "name", label: "礼品券名称", minWidth: "200", },
          { prop: "subTitle", label: "礼品券标题", minWidth: "200", },
          { prop: "useTime", label: "券有效时间", minWidth: "200", },
          { prop: "useRangeType", label: "使用范围", minWidth: "200", },
        ]
      }else if (value === 'LotCoupon') {
        this.couponSelectData = this.parkingCouponListData
        this.tableThData = [
        { prop: "name", label: "停车券名称", minWidth: "200", },
        { prop: "mallName", label: "商场名", minWidth: "200", },
        { prop: "discount", label: "抵扣", minWidth: "200", },
        { prop: "validTime", label: "券有效时间", minWidth: "200", },
        { prop: "remark", label: "说明", minWidth: "200", },
        ]
      }
    },
    // 返回
    onBack() {
    this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.rule-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;

  .el-input,
  .el-textarea,
  .el-select,
  .el-date-editor,
  .el-cascader {
    width: 350px;
  }
  .radioInput.el-form-item{
    display: inline-block;
    margin-left: 10px;
    .el-input{
      width: 150px;
    }
  }
   .point-record {
    margin-top: 60px;

    .el-divider {
      margin-bottom: 20px;
    }
  }
   .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }
  .button-box{
    text-align: left;
    margin-top: 50px;

    &.right {
      text-align: right;
    }
  }
  .W200 {
    width: 200px;
  }

  .disLB {
    display: inline-block;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }

  .footer {
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
  .coupon-table {
    width: 80%;
    margin-left: 100px;
    margin-bottom: 20px;
  }
  .image{
    width: 120px;
    height: 120px;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
}
</style>
